import { render, staticRenderFns } from "./CopyEmployeePermissionForm.vue?vue&type=template&id=6c78258a&"
import script from "./CopyEmployeePermissionForm.vue?vue&type=script&lang=js&"
export * from "./CopyEmployeePermissionForm.vue?vue&type=script&lang=js&"
import style0 from "./CopyEmployeePermissionForm.vue?vue&type=style&index=0&id=6c78258a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports